import { useSelector } from 'react-redux';

import type {
  MediaItem,
  ProductMediaState,
} from 'src/components/organisms/ProductMediaCarousel/types';
import { selectProductMedia } from 'src/redux/product/selectors';
import { selectCurrentMedia, selectIsModalOpen } from 'src/redux/productMediaCarousel/selectors';

/**
 * View model for the full-screen media modal. Owns the reads for what the modal
 * shows and whether it is open, so the modal takes props and its interaction
 * handlers come from useProductMediaModalActions alongside.
 *
 * The media list and current index are the same state the carousel reads, which is
 * what keeps the two in step: opening the modal on the third image shows the third
 * image, and navigating in the modal leaves the carousel on the media you stopped on.
 */
export interface ProductMediaModalViewModel {
  currentMedia: ProductMediaState['currentMedia'];
  isModalOpen: ProductMediaState['isModalOpen'];
  media: MediaItem[];
}

export const useProductMediaModalViewModel = (): ProductMediaModalViewModel => ({
  currentMedia: useSelector(selectCurrentMedia),
  isModalOpen: useSelector(selectIsModalOpen),
  media: useSelector(selectProductMedia),
});
